export const SCOOTER_PACKAGE_ALERT_DATA_TEST_ID = 'scooter-package_alert';
export const MARINE_ENGINE_ALERT_DATA_TEST_ID = 'marine-engine_alert';
export const YAMT_TRANSMISSION_ALERT_DATA_TEST_ID = 'yamt_transmission_alert';
